import CommonRouterSection from '@/components/layout/CommonRouterSection'

export default {
  path: '/search',
  name: 'search',
  component: CommonRouterSection,
  children: [  
    {
      path: 'keyword-search',
      name: 'keyword-search',
      component: () => import('@/views/search/KeywordSearch.vue')
    },
    {
      path: 'search-wizard',
      name: 'search-wizard',
      component: () => import('@/views/search/SearchWizard.vue')
    },
    {
      path: 'advanced-search/:domain',
      name: 'advanced-search',
      component: () => import('@/views/search/AdvancedSearch.vue')
    },
    {
      path: 'result/:domain([a-zA-Z\\-]+)',
      name: 'result',
      component: () => import('@/views/search/Result.vue')
    },
    {
      path: 'result/:domain/:pageSeq',
      name: 'result-detail',
      component: () => import('@/views/search/ResultDetail.vue')
    },
    {
      path: 'result/:domain/application/:applicationSeq(\\d+)',
      name: 'result-application',
      component: () => import('@/views/search/ResultDetail.vue')
    },
  ]
}
